import { NotaApi } from "./api/NotaApi";
export class NotaService {
    static async gerar(formData) {
        try {
            const response = await NotaApi.gerar(formData);
            return response;
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    }

    static async getEmpresas() {
        try {
            const response = await NotaApi.getEmpresas();
            return response;
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    }
}